var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "datepicker-buttons-container flex justify-content-right",
      class: [{ "is-dark": _vm.dark }]
    },
    [
      _c(
        "b-button-group",
        [
          _vm.hasButtonNow
            ? _c(
                "fup-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.emitNow()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.buttonNowTranslation || "Сейчас"))]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.hasButtonValidate
            ? _c(
                "fup-button",
                {
                  attrs: { variant: "warning" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.$emit("validate")
                    }
                  }
                },
                [
                  _c("fup-icon", { attrs: { name: "check" } }),
                  _vm._v(
                    " " + _vm._s(_vm.buttonValidateTranslation || "Готово")
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }